import uuid from "uuid/v4";
import { readCartData, writeCartData } from "../../util/cart/cartStorage";
import {
  ADD_TO_CART,
  DECREASE_QUANTITY,
  DELETE_FROM_CART,
  DELETE_ALL_FROM_CART,
  ADDDATA_TO_CART, DELETE_PRODUCT_FROM_CART,
  DELETE_SIZE_FROM_CART, EDIT_QTY_CART,
  DELETE_DECO_CART
} from "../actions/cartActions";

const initState = [];

const cartReducer = (state = initState, action) => {
  const cartItems = state,
    product = action.payload;
  if (action.type === ADDDATA_TO_CART) {
    return action.payload;
  }
  if (action.type === ADD_TO_CART) {
    // for non variant products
    if (product.variation === undefined) {
      const cartItem = cartItems.filter(item => item.id === product.id)[0];
      if (cartItem === undefined) {
        return [
          ...cartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid()
          }
        ];
      } else {
        return cartItems.map(item =>
          item.cartItemId === cartItem.cartItemId
            ? {
              ...item,
              quantity: product.quantity
                ? item.quantity + product.quantity
                : item.quantity + 1
            }
            : item
        );
      }
      // for variant products
    } else {
      const cartItem = cartItems.filter(
        item =>
          item.id === product.id &&
          product.selectedProductColor &&
          product.selectedProductColor === item.selectedProductColor &&
          product.selectedProductSize &&
          product.selectedProductSize === item.selectedProductSize &&
          (product.cartItemId ? product.cartItemId === item.cartItemId : true)
      )[0];

      if (cartItem === undefined) {
        return [
          ...cartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid()
          }
        ];
      } else if (
        cartItem !== undefined &&
        (cartItem.selectedProductColor !== product.selectedProductColor ||
          cartItem.selectedProductSize !== product.selectedProductSize)
      ) {
        return [
          ...cartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid()
          }
        ];
      } else {
        return cartItems.map(item =>
          item.cartItemId === cartItem.cartItemId
            ? {
              ...item,
              quantity: product.quantity
                ? item.quantity + product.quantity
                : item.quantity + 1,
              selectedProductColor: product.selectedProductColor,
              selectedProductSize: product.selectedProductSize
            }
            : item
        );
      }
    }
  }

  if (action.type === DECREASE_QUANTITY) {
    if (product.quantity === 1) {
      const remainingItems = (cartItems, product) =>
        cartItems.filter(
          cartItem => cartItem.cartItemId !== product.cartItemId
        );
      return remainingItems(cartItems, product);
    } else {
      return cartItems.map(item =>
        item.cartItemId === product.cartItemId
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    }
  }

  if (action.type === DELETE_FROM_CART) {
    const remainingItems = (cartItems, product) =>
      cartItems.filter(cartItem => cartItem.cartItemId !== product.cartItemId);
    return remainingItems(cartItems, product);
  }
  if (action.type === DELETE_PRODUCT_FROM_CART) {
    const isSameEntry = (cartItem, product) => {
      const a = cartItem.currentOrder?.[0]?.[0];
      const b = product.currentOrder?.[0]?.[0];
      if (!a || !b) return cartItem.item.id === product.item.id;
      return a.product?.sku === b.product?.sku && a.color === b.color;
    };
    const nextData = readCartData().filter(cartItem => !isSameEntry(cartItem, product));
    const written = writeCartData(nextData);
    if (!written.ok) return state;
    const remainingItems = (cartItems, product) =>
      cartItems.filter(cartItem => !isSameEntry(cartItem, product));
    return remainingItems(cartItems, product);
  }
  if (action.type === DELETE_SIZE_FROM_CART) {
    let sizeindexTemp = action.sizeindex
    let rowIndexTemp = action.rowIndex
    const targetColor = product.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color;

    const remainingItems = (cartItems, product) => {
      let cData = readCartData();
      cData = cData.filter(cartItem => {
        if (targetColor !== undefined && cartItem.item.id == product.item.id && cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color === targetColor) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRow = tempOrder[rowIndexTemp];
            if (tempRow[sizeindexTemp]) {
              tempRow = tempRow.filter((rowSata, key) => key !== sizeindexTemp)
              tempOrder[rowIndexTemp] = tempRow;
            }
            tempOrder[rowIndexTemp] = tempRow
          }
          tempOrder = tempOrder.filter(rowArray => rowArray.length)
          cartItem.currentOrder = tempOrder;
          return cartItem;
        } else {
          return cartItem
        }

      });
      cData = cData.filter(item => item.currentOrder.length)
      const written = writeCartData(cData);
      if (!written.ok) return null;
      cartItems = cartItems.map(cartItem => {
        if (targetColor !== undefined && cartItem.item.id == product.item.id && cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color === targetColor) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRow = tempOrder[rowIndexTemp];
            if (tempRow[sizeindexTemp]) {
              tempRow = tempRow.filter((rowSata, key) => key !== sizeindexTemp)
              tempOrder[rowIndexTemp] = tempRow;
            }
            tempOrder[rowIndexTemp] = tempRow
          }
          tempOrder = tempOrder.filter(rowArray => rowArray.length)
          cartItem.currentOrder = tempOrder;
          return cartItem;
        } else {
          return cartItem
        }
      });
      cartItems = cartItems.filter(item => item.currentOrder.length)
      return cartItems
    }
    const result = remainingItems(cartItems, product);
    return result === null ? state : result;
  }
  if (action.type === EDIT_QTY_CART) {
    let sizeindexTemp = action.sizeindex
    let rowIndexTemp = action.rowIndex
    let qtyTemp = action.qty
    const remainingItems = (cartItems, product) => {
      let cData = readCartData();
      const targetColor = product.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color;
      const targetSize = product.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.size;

      cData = cData.map(cartItem => {
        if (targetColor !== undefined && targetSize !== undefined &&
            cartItem.item.id == product.item.id &&
            cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color === targetColor &&
            cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.size === targetSize) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRow = tempOrder[rowIndexTemp];
            if (tempRow[sizeindexTemp]) {
              tempRow[sizeindexTemp].quantity = qtyTemp
            }
          }
          cartItem.currentOrder = tempOrder;
        }
        return cartItem;
      });
      cData = cData.filter(item => item.currentOrder.length)
      const written = writeCartData(cData);
      if (!written.ok) return null;
      cartItems = cartItems.map(cartItem => {
        if (targetColor !== undefined && targetSize !== undefined &&
            cartItem.item.id == product.item.id &&
            cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.color === targetColor &&
            cartItem.currentOrder[rowIndexTemp]?.[sizeindexTemp]?.size === targetSize) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRow = tempOrder[rowIndexTemp];
            if (tempRow[sizeindexTemp]) {
              tempRow[sizeindexTemp].quantity = qtyTemp
            }
          }
          cartItem.currentOrder = tempOrder;
        }
        return cartItem;
      });
      cartItems = cartItems.filter(item => item.currentOrder.length)
      return cartItems
    }
    const result = remainingItems(cartItems, product);
    return result === null ? state : result;
  }
  if (action.type === DELETE_DECO_CART) {

    let rowIndexTemp = action.rowIndex
    let decoIndexTemp = action.decoIndex
    const targetColor = product.currentOrder[rowIndexTemp]?.[0]?.color;

    const remainingItems = (cartItems, product) => {
      let cData = readCartData();
      cData = cData.filter(cartItem => {
        if (targetColor !== undefined && cartItem.item.id == product.item.id && cartItem.currentOrder[rowIndexTemp]?.[0]?.color === targetColor) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRows = tempOrder[rowIndexTemp];
            tempRows = tempRows.filter(rowData => {
              if (rowData.decoration[decoIndexTemp]) {
                rowData.decoration = rowData.decoration.filter((deco, key) => key !== decoIndexTemp)
              }
              return rowData
            })
            tempOrder[rowIndexTemp] = tempRows
          }
          tempOrder = tempOrder.filter(rowArray => rowArray.length)
          cartItem.currentOrder = tempOrder;
          return cartItem;
        } else {
          return cartItem
        }

      });
      cData = cData.filter(item => item.currentOrder.length)
      const written = writeCartData(cData);
      if (!written.ok) return null;
      cartItems = cartItems.map(cartItem => {
        if (targetColor !== undefined && cartItem.item.id == product.item.id && cartItem.currentOrder[rowIndexTemp]?.[0]?.color === targetColor) {
          let tempOrder = cartItem.currentOrder
          if (tempOrder[rowIndexTemp]) {
            let tempRows = tempOrder[rowIndexTemp];
            tempRows = tempRows.filter(rowData => {
              if (rowData.decoration[decoIndexTemp]) {
                rowData.decoration = rowData.decoration.filter((deco, key) => key !== decoIndexTemp)
              }
              return rowData
            })
            tempOrder[rowIndexTemp] = tempRows
          }
          tempOrder = tempOrder.filter(rowArray => rowArray.length)
          cartItem.currentOrder = tempOrder;
          return cartItem;
        } else {
          return cartItem
        }
      });
      cartItems = cartItems.filter(item => item.currentOrder.length)
      return cartItems
    }
    const result = remainingItems(cartItems, product);
    return result === null ? state : result;
  }

  if (action.type === DELETE_ALL_FROM_CART) {
    const written = writeCartData([]);
    if (!written.ok) return state;

    return cartItems.filter(item => {
      return false;
    });
  }

  return state;
};

export default cartReducer;
